import request from '@/utils/request'
import { getToken } from '../../utils/auth'

// 查询代管物品
export function querygoodsperson (params, data) {
  params.token = getToken()
  return request({ url: '/querygoodsperson', method: 'post', params, data })
}

// 创建代管物品
export function creategoodsperson (data) {
  return request({ url: '/creategoodsperson', method: 'post', params: { token: getToken() }, data })
}

// 更新代管物品
export function updategoodsperson (data) {
  return request({ url: '/updategoodsperson', method: 'post', params: { token: getToken() }, data })
}



// WEBPACK FOOTER //
// ./src/api/yanglaoyuan/goodsperson.js